import React from 'react'
import styled from 'styled-components'

const CardFullWidth = styled.div.attrs({
  className: 'ui'
})`
  &&& {
    width: 100%;
  }
`

export const FeatureImage = ({
  imgSrc = 'https://virtual-race-submissions.s3-ap-southeast-1.amazonaws.com/images/WEB-BANNER-B-1900X1000-jpg-2j412092018-140238'
}) => (
  <CardFullWidth>
    <div className="image">
      <img src={imgSrc} />
    </div>
  </CardFullWidth>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/FeatureImage/index.js